import { apiFetch, setToken, clearToken } from "./client";

export async function login(username, password) {
  const data = await apiFetch("/api/auth/login", {
    method: "POST",
    auth: false,
    body: { username, password },
  });

  setToken(data.token);
  return data;
}

export function logout() {
  clearToken();
}
